const BATCH_SMS_CONSTANTS = {
  BATCH_SMS: 'BatchSms',
  VIEW_BATCH_SMS: 'BatchSms/ViewInstance/:InstanceUID',
  CREATE_BATCH_SMS: 'CreateBatchSms',
};
export default BATCH_SMS_CONSTANTS;
